import Image from "next/image";
const imageLoader = ({ src, width, quality }) => {
	return src;
};

export const RAImage = ({
	url = "",
	width = "100%",
	height = "auto",
	quality = 100,
	borderRadius = 0,
	objectFit = "cover",
	objectPosition = undefined,
	sizes,
	alt = "",
	...props
}) => (
	<div
		style={{
			position: "relative",
			width: width,
			height: height,
		}}
		{...props}
	>
		<Image
			loader={imageLoader}
			alt={alt || url?.toString()}
			src={url}
			fill
			quality={quality}
			priority
			sizes={sizes || "100vw"}
			style={{
				objectFit: objectFit,
				borderRadius: borderRadius,
				objectPosition: objectPosition,
			}}
		/>
	</div>
);
